import { observable, action, runInAction } from 'mobx'
import { fetchUsers, User } from 'pages/Home/PopulationManagement/usersApi'

class ImsUsersStore {

  @observable allUsers: User[] = []
  @observable users: User[] = []
  @observable loading = false

  // Counts the loads issued, so only the newest one may write. Every caller
  // still gets its own request: a reload asked for after a save must not be
  // answered by one that was already in flight before it, which would show the
  // rows as they were before the save.
  private requestSeq = 0

  @action load = async (communityId: number) => {
    const seq = ++this.requestSeq
    this.loading = true
    try {
      const res = await fetchUsers(communityId)
      // An earlier request landing late would put back rows that a later load -
      // or a switch to another community - has already replaced.
      if (seq === this.requestSeq) {
        runInAction(() => {
          this.allUsers = res.data
          this.users = res.data
        })
      }
    } finally {
      if (seq === this.requestSeq) {
        runInAction(() => {
          this.loading = false
        })
      }
    }
  }

  @action removeUser = (userId: number) => {
    // The table renders from allUsers, so it must be filtered for the optimistic
    // removal to be visible; keep users in sync too.
    this.allUsers = this.allUsers.filter((u: any) => (u.userId ?? u.id) !== userId)
    this.users = this.users.filter((u: any) => (u.userId ?? u.id) !== userId)
  }
}

const imsUsersStore = new ImsUsersStore()
export default imsUsersStore
